import React from 'react';
import { injectIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

import Loader from '../../../components/Common/Loader/Loader';
import CategoryTree from '../../../components/Category/CategoryTree';
import { getCategoryTreeQuery } from '../../../lib/graphql';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

import messages from '../../../locale/messages';

function Category({ intl: { formatMessage } }) {

  const { data, loading, refetch } = useQueryResponse({
    query: getCategoryTreeQuery,
    fetchPolicy: 'network-only'
  });

  const categoryDetails = {
    ...data,
    loading,
    refetch
  };

  return (
    <Loader type="page" show={loading}>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.categoryMenu)}</h1>
      <CategoryTree categoryDetails={categoryDetails} />
    </Loader>
  );
}

export default injectIntl(Category);
